import { addDistrict } from "../../../../../actions/Utilities/District";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { addStateDistrict } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import useSendEmail from "../../hooks/useSendEmail";

const useAddDistrict = () => {
  const queryClient = useQueryClient();
  const [, setActionAddState] = useRecoilState(addStateDistrict);
  const { mutateAsync: sendEmail } = useSendEmail();

  const { mutate } = useMutation(
    (districtNewData) => addDistrict(districtNewData),
    {
      onSuccess: (res) => {
        if (res === "Duplicate") {
          toast.fire(
            "Saving Failed",
            "District Name or District Code already exists!",
            "warning"
          );
        } else {
          queryClient.invalidateQueries(["GetDistrict"]);
          sendEmail(res.data, {
            onSuccess: (res) => {
              if (res) {
                if (res.status === 400) {
                  toast.fire(
                    "Success",
                    "District Added Successfully, but failed in sending email",
                    "warning"
                  );
                } else {
                  toast.fire(
                    "Success",
                    "District Added Successfully",
                    "success"
                  );
                }
              }
            },
          });
          setActionAddState(false);
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Add District!", "error");
      },
    }
  );

  return mutate;
};
export default useAddDistrict;
